// SPDX-FileCopyrightText: 2024 Comcast
//
// SPDX-License-Identifier: LicenseRef-Comcast

import { ChannelDevice } from './channelDevice';

export class SmsDeviceInformation extends ChannelDevice{
    phoneNumber: string;
}